import React from 'react'

import { Checkbox } from '@plurall/elo-beta'
import { FormErrorMessage } from 'App/components/FormError'

import styles from './CoordinatorData.module.css'

const CoordinatorForm = ({
  onSubmitForm,
  learningLevels,
  errors,
  graphQLError,
  values,
  toggleAllChecked,
  handleChange,
}) => {
  return (
    <form onSubmit={onSubmitForm}>
      <div className={styles.checkboxGroup}>
        <Checkbox
          name='checkAll'
          label='Selecionar todos os Níveis de Ensino'
          checked={values.checkAll}
          onChange={() => toggleAllChecked(values.checkAll)}
          dataTestId='checkAll'
        />
        {!learningLevels.length && (
          <FormErrorMessage error='Nenhum Nível de ensino encontrado' className={styles.error} />
        )}
        {learningLevels &&
          learningLevels.map(ll => {
            return (
              <Checkbox
                name={ll.name}
                label={ll.name}
                checked={values[ll.name]}
                dataTestId={ll.name}
                key={ll.name}
                onChange={() => {
                  handleChange({
                    name: ll.name,
                    value: !values[ll.name],
                  })
                }}
              />
            )
          })}
      </div>
      <div data-test='learningLevels' data-test-id='learningLevels'>
        {errors?.levels && <FormErrorMessage error={errors?.levels} />}
        {graphQLError && <FormErrorMessage error={graphQLError} />}
      </div>
    </form>
  )
}

export { CoordinatorForm }
